(function ($) {
  'use strict';

  const ITEM_ID = '10107869';
  const SHOP_BID = '203706';
  const VARIANT_ID = '555a00051';

  const BASE_IMG = 'https://www.rakuten.ne.jp/gold/arne/size_order/images/wb/sttype/';
  const EXISTING_URL = 'https://interior-arne.com/products/';

  const LIMITS = {
    haba: { min: 40, max: 180, label: '幅' },
    depth: { min: 15, max: 25, label: '奥行' },
    height: { min: 15, max: 40, label: '高さ' }
  };

  const MATERIAL_TEXT = {
    wood: 'リーズナブル木目：<br>[材質]プリント化粧合板',
    aino: 'パステルカラーaino：<br>[材質]強化紙化粧合板',
    mela: 'ハイグレード鏡面仕上げ：<br>[材質]メラミン樹脂化粧合板(アイカ工業製)'
  };

  const COLOR_BAND = {
    A: ['wood', 'aino'],
    B: ['nail', 'bk', 'bp'],
    C: ['mb', 'gs', 'ww']
  };

  const ROW_BASE_BY_DEPTH_AND_BAND = {
    shallow: { A: 0, B: 18, C: 36 },
    middle: { A: 6, B: 24, C: 42 },
    deep: { A: 12, B: 30, C: 48 }
  };

  const OPTION_HOLE_PRICE = 1500;

  const HOLE_PANEL_DATA = {
    panel_a: {
      letter: 'a',
      viewText: '板面：Aを正面から見て',
      targetName: '背板',
      options: ['左上', '中央上', '右上', '中央左', '中央', '中央右', '左下', '中央下', '右下']
    },
    panel_b: {
      letter: 'b',
      viewText: '板面：Bを側面から見て',
      targetName: '左側板',
      options: ['左上', '右上(開口部側)', '中央', '左下', '右下(開口部側)']
    },
    panel_c: {
      letter: 'c',
      viewText: '板面：Cを側面から見て',
      targetName: '右側板',
      options: ['左上(開口部側)', '右上', '中央', '左下(開口部側)', '右下']
    },
    panel_d: {
      letter: 'd',
      viewText: '板面：Dを底面から見て',
      targetName: '底面',
      options: ['左奥', '中央奥', '右奥', '中央左', '中央', '中央右', '左手前(開口部側)', '中央手前(開口部側)', '右手前(開口部側)']
    }
  };

  const HOLE_PANEL_ORDER = ['panel_a', 'panel_b', 'panel_c', 'panel_d'];

  let priceTable = null;
  let existingList = null;

  function onlyDigits(v) {
    return String(v == null ? '' : v).replace(/[^\d]/g, '');
  }

  function readInt(id) {
    const el = document.getElementById(id);
    if (!el) return { el: null, val: NaN, isEmpty: true };
    const cleaned = onlyDigits(el.value);
    if (el.value !== cleaned) el.value = cleaned;
    return {
      el: el,
      val: cleaned === '' ? NaN : parseInt(cleaned, 10),
      isEmpty: cleaned === ''
    };
  }

  function ceil5(n) {
    return Math.ceil(n / 5) * 5;
  }

  function formatYen(n) {
    const s = String(n == null ? '' : n).replace(/[^\d]/g, '');
    if (!s) return '';
    return s.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '円';
  }

  function formatApprox(n) {
    if (!Number.isFinite(n)) return '';
    const rounded = Math.round(n * 10) / 10;
    if (Math.abs(rounded - Math.round(rounded)) < 1e-9) return '約' + Math.round(rounded) + 'cm';
    return '約' + rounded.toFixed(1) + 'cm';
  }

  function getSelectedColor() {
    return $('input[name="colortype"]:checked');
  }

  function getSelectedColorName() {
    return getSelectedColor().val() || '';
  }

  function getSelectedColorId() {
    return getSelectedColor().attr('id') || '';
  }

  function getSelectedMaterialType() {
    return String(getSelectedColor().data('type') || '').toLowerCase();
  }

  function normalizeColorToken() {
    const type = getSelectedMaterialType();
    const id = getSelectedColorId().toLowerCase();
    if (type === 'wood' || type === 'aino') return type;
    if (id.indexOf('mela_') === 0) return id.replace(/^mela_/, '');
    return String(getSelectedColorName() || '').toLowerCase();
  }

  function getBandByColor() {
    const token = normalizeColorToken();
    if (COLOR_BAND.A.indexOf(token) !== -1) return 'A';
    if (COLOR_BAND.B.indexOf(token) !== -1) return 'B';
    if (COLOR_BAND.C.indexOf(token) !== -1) return 'C';
    return null;
  }

  function getImagePattern() {
    return readInt('haba').val === 40 && readInt('height').val === 40 ? '402140' : '1202130';
  }

  function $sizeMsg() {
    return $('.form_size').closest('.form').find('> .msg').first();
  }

  function $orderMsg() {
    return $('.order-summary > .msg');
  }

  function setCheckoutUIEnabled(on) {
    const $price = $('.check_price');
    const $cart = $('.cart--btn');
    if (on) {
      $price.css('visibility', 'visible');
      $cart.prop('disabled', false);
    } else {
      $price.css('visibility', 'hidden');
      $cart.prop('disabled', true);
    }
  }

  function resetOrderSummary() {
    $orderMsg().empty();
    $('.check_area li span').text('');
    $('.check_price').empty();
    setCheckoutUIEnabled(false);
    $('#units').val('');
  }

  function loadPriceOnce() {
    if (Array.isArray(priceTable)) return $.Deferred().resolve(priceTable).promise();
    return $.ajax({ url: 'https://cdn.shopify.com/s/files/1/0549/1834/8887/files/wb-st_price.csv', dataType: 'text' }).then(function (text) {
      priceTable = $.csv.toArrays(text).map(function (row) {
        return row.map(function (v) {
          return parseInt(String(v).replace(/[^\d]/g, ''), 10);
        });
      });
      return priceTable;
    }).catch(function () {
      priceTable = [];
      return priceTable;
    });
  }

  function loadExistingOnce() {
    if (Array.isArray(existingList)) return $.Deferred().resolve(existingList).promise();
    return $.ajax({ url: 'https://cdn.shopify.com/s/files/1/0549/1834/8887/files/wb-st_existing.csv', dataType: 'text' }).then(function (text) {
      existingList = $.csv.toArrays(text);
      return existingList;
    }).catch(function () {
      existingList = [];
      return existingList;
    });
  }

  function setMaterialBubble() {
    const type = getSelectedMaterialType();
    $('.material .material_bubble').html(MATERIAL_TEXT[type] || '選択してください');
  }

  function resizeFormSizeImages() {
    const $wrap = $('.form_size--img');
    if (!$wrap.length) return;
    const width = $wrap.width();
    let maxHeight = 0;

    $wrap.find('img').each(function () {
      if (width) $(this).css('width', width + 'px');
      const height = $(this).height();
      if (height > maxHeight) maxHeight = height;
    });

    if (maxHeight > 0) $wrap.height(maxHeight);
  }

  function bindResizeAfterLoad() {
    $('.form_size--img img').off('load.wbStResize').on('load.wbStResize', resizeFormSizeImages);
  }

  function updatePreviewImages() {
    const pattern = getImagePattern();
    const colorId = getSelectedColorId() || 'wood_br';
    const area1 = document.querySelector('.form_size--img img[name="area1"]');
    const area2 = document.querySelector('.form_size--img img[name="area2"]');
    const area3 = document.querySelector('.form_size--img img[name="area3"]');

    if (area1) area1.src = BASE_IMG + 'arrow.png';
    if (area2) area2.src = BASE_IMG + colorId + '.png';
    if (area3) area3.src = BASE_IMG + colorId + '.png';
    resizeFormSizeImages();
  }

  function calcInnerWidth(value, type) {
    return type === 'mela' ? value - 3.4 : value - 3.6;
  }

  function calcInnerDepth(value, type) {
    return type === 'mela' ? value - 4.2 : value - 4.4;
  }

  function calcInnerHeight(value, type) {
    return type === 'mela' ? value - 2 : value - 2.1;
  }

  function updateInnerDisplayOne(key) {
    const rec = readInt(key);
    const limit = LIMITS[key];
    const type = getSelectedMaterialType() || 'wood';
    let outputId = '';
    let value = NaN;

    if (key === 'haba') {
      outputId = 'haba_id';
      value = calcInnerWidth(rec.val, type);
    } else if (key === 'depth') {
      outputId = 'depth_id';
      value = calcInnerDepth(rec.val, type);
    } else if (key === 'height') {
      outputId = 'height_id';
      value = calcInnerHeight(rec.val, type);
    }

    if (!outputId) return;
    if (rec.isEmpty || !Number.isFinite(rec.val) || rec.val < limit.min || rec.val > limit.max) {
      $('#' + outputId).val('');
      return;
    }
    $('#' + outputId).val(formatApprox(value));
  }

  function updateInnerDisplays() {
    updateInnerDisplayOne('haba');
    updateInnerDisplayOne('depth');
    updateInnerDisplayOne('height');
  }

  function removeSizeError(key) {
    $sizeMsg().find('.note-size-error[data-error-key="' + key + '"]').remove();
  }

  function setSizeError(key, text) {
    removeSizeError(key);
    if (text) $sizeMsg().append($('<p class="note-size-error">').attr('data-error-key', key).text(text));
  }

  function validateSizeFieldForBlur(key) {
    const limit = LIMITS[key];
    const rec = readInt(key);
    if (rec.isEmpty) {
      removeSizeError(key);
      return;
    }
    if (!Number.isFinite(rec.val) || rec.val < limit.min || rec.val > limit.max) {
      setSizeError(key, limit.label + 'は' + limit.min + '〜' + limit.max + 'cmの範囲で入力してください（現在：' + (Number.isFinite(rec.val) ? rec.val : '') + 'cm）');
      return;
    }
    removeSizeError(key);
  }

  function buildJumpSizeErrors() {
    const errors = [];
    ['haba', 'depth', 'height'].forEach(function (key) {
      const limit = LIMITS[key];
      const rec = readInt(key);
      if (rec.isEmpty) {
        errors.push(limit.label + 'を入力してください');
      } else if (!Number.isFinite(rec.val) || rec.val < limit.min || rec.val > limit.max) {
        errors.push(limit.label + 'は' + limit.min + '〜' + limit.max + 'cmの範囲で入力してください（現在：' + rec.val + 'cm）');
      }
    });
    return errors;
  }

  function getExistingColorKey() {
    const type = getSelectedMaterialType();
    if (type === 'mela') return getSelectedColorId().toLowerCase();
    return type;
  }

  function findExistingCode(data) {
    if (!Array.isArray(existingList)) return null;
    for (let i = 0; i < existingList.length; i++) {
      const row = existingList[i] || [];
      const code = String(row[0] || '').trim();
      const width = parseInt(String(row[1] || '').replace(/[^\d]/g, ''), 10);
      const depth = parseInt(String(row[2] || '').replace(/[^\d]/g, ''), 10);
      const height = parseInt(String(row[3] || '').replace(/[^\d]/g, ''), 10);
      const color = String(row[4] || '').trim().toLowerCase();
      if (code && width === data.haba && depth === data.depth && height === data.height && color === String(data.color).toLowerCase()) {
        return code;
      }
    }
    return null;
  }

  function getShopMark(haba, depth, height) {
    return haba + depth + height + 10 <= 200 ? '★' : '☆';
  }

  function getSelectedHolePanelKey() {
    return $('input[name="op_panel"]:checked').attr('id') || '';
  }

  function getSelectedHolePosition() {
    const value = $('select[name="op_hole--position"]').val() || '';
    return value === '穴位置を選択' ? '' : value;
  }

  function getHoleOptionText() {
    if (!$('#op_hole').prop('checked')) return '';
    const panelData = HOLE_PANEL_DATA[getSelectedHolePanelKey()];
    const position = getSelectedHolePosition();
    if (!panelData || !position) return '';
    return '配線穴(' + panelData.targetName + 'の' + position + ')';
  }

  function resetHolePositionSelect() {
    $('select[name="op_hole--position"]').empty().append(
      $('<option>').text('穴位置を選択').val('穴位置を選択')
    );
  }

  function syncHoleArea() {
    const enabled = $('#op_hole').prop('checked');
    $('.op_hole-area').toggle(enabled);
    $('.op_hole--position').toggle(enabled && $('input[name="op_panel"]:checked').length > 0);

    if (!enabled) {
      $('input[name="op_panel"]').prop('checked', false);
      resetHolePositionSelect();
      $('.op_hole--position').hide();
    }
  }

  function renderHolePanel(panelKey) {
    const data = HOLE_PANEL_DATA[panelKey];
    if (!data) return;

    $('.op_hole--position p span').html(
      data.viewText + '<img src="' + BASE_IMG + 'panel_choice-' + data.letter + '.png">'
    );

    const $select = $('select[name="op_hole--position"]');
    resetHolePositionSelect();
    data.options.forEach(function (label) {
      $select.append($('<option>').text('穴位置：' + label).val(label));
    });
    $('.op_hole--position').show();
  }

  window.choicePanel = function choicePanel(index) {
    renderHolePanel(HOLE_PANEL_ORDER[index]);
  };

  function setChoiceValues(data) {
    $('#choice1').val('幅：' + data.haba + 'cm/');
    $('#choice2').val('奥行：' + data.depth + 'cm/');
    $('#choice3').val('高さ：' + data.height + 'cm/');
    $('#choice4').val('カラー：' + data.color + '/');
    $('#choice5').val('オプション：' + (data.optionText || 'なし') + '/');
    $('#choice6').val('店舗用記号：' + data.shopMark + '/');
    $('#choice7').val('見積もり金額：' + data.price);
    $('#units').val(String(Math.round(data.price / 100)));
  }

  function buildEncodedChoice() {
    const lines = [];
    for (let i = 1; i <= 7; i++) {
      const value = $('#choice' + i).val();
      if (String(value || '').length) lines.push(value);
    }
    const choice = lines.join('\r\n');
    const unicodeArray = Encoding.stringToCode(choice);
    const eucArray = Encoding.convert(unicodeArray, { to: 'EUCJP', from: 'UNICODE' });
    return Encoding.urlEncode(eucArray);
  }

  function submitToRakutenCart(e) {
    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    const units = $('#units').val();
    if (!units || !$('#choice1').val() || !$('#choice7').val()) return false;

    const oldForm = document.querySelector('form[name="cart_form_ori"]');
    if (oldForm) oldForm.remove();

    const form = document.createElement('form');
    form.method = 'post';
    form.name = 'cart_form_ori';
    form.action = 'https://basket.step.rakuten.co.jp/rms/mall/bs/cartadd/set';
    form.acceptCharset = 'EUC-JP';
    form.target = '_blank';

    [
      { name: 'shop_bid', value: SHOP_BID },
      { name: 'item_id', value: ITEM_ID },
      { name: 'variant_id', value: VARIANT_ID },
      { name: 'units', value: units },
      { name: 'choice', value: buildEncodedChoice() }
    ].forEach(function (item) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = item.name;
      input.value = item.value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    return false;
  }

  function priceRowFor(height5, band, depth) {
    let depthKey = 'deep';
    if (depth <= 15) depthKey = 'shallow';
    else if (depth <= 20) depthKey = 'middle';
    const base = ROW_BASE_BY_DEPTH_AND_BAND[depthKey][band];
    if (base == null) return NaN;
    return base + Math.round((height5 - 15) / 5);
  }

  function priceColFor(width5) {
    return Math.round((width5 - 40) / 5);
  }

  window.jump = function jump() {
    resetOrderSummary();
    const $msg = $orderMsg();
    const sizeErrors = buildJumpSizeErrors();
    const color = getSelectedColorName();
    const materialType = getSelectedMaterialType();
    const band = getBandByColor();
    const holeOn = $('#op_hole').prop('checked');
    const holePanel = getSelectedHolePanelKey();
    const holePosition = getSelectedHolePosition();

    if (sizeErrors.length) {
      sizeErrors.forEach(function (text) {
        $msg.append($('<p class="note-submit-error">').text(text));
      });
      return false;
    }

    if (!color || !materialType || !band) {
      $msg.append($('<p class="note-submit-error">').text('カラーを選択してください'));
      return false;
    }

    if (holeOn && (!holePanel || !holePosition)) {
      $msg.append($('<p class="note-submit-error">').text('配線穴の板面と穴位置を選択してください'));
      return false;
    }

    if (!Array.isArray(priceTable) || !priceTable.length) {
      $msg.append($('<p class="note-submit-error">').text('価格表の読み込みに失敗しました'));
      return false;
    }

    const haba = readInt('haba').val;
    const depth = readInt('depth').val;
    const height = readInt('height').val;
    const row = priceRowFor(ceil5(height), band, depth);
    const col = priceColFor(ceil5(haba));
    const basePrice = priceTable[row] && priceTable[row][col];

    if (!Number.isFinite(basePrice)) {
      $msg.append($('<p class="note-submit-error">').text('価格が見つかりませんでした'));
      return false;
    }

    const existingCode = !holeOn ? findExistingCode({
      haba: haba,
      depth: depth,
      height: height,
      color: getExistingColorKey()
    }) : null;

    if (existingCode) {
      $msg.append(
        '<p class="existing-link"><a href="' + EXISTING_URL + existingCode + '" target="_blank">' +
        '→既製品ページがございます。こちらのページよりお買い求めください。</a></p>'
      );
      return false;
    }

    let price = basePrice;
    if (materialType === 'aino') price += 1000;
    if (holeOn) price += OPTION_HOLE_PRICE;

    const optionText = getHoleOptionText();
    const spans = document.querySelectorAll('.check_area ul li span');
    if (spans.length >= 5) {
      spans[0].textContent = haba;
      spans[1].textContent = depth;
      spans[2].textContent = height;
      spans[3].textContent = color;
      spans[4].textContent = optionText || 'なし';
    }

    setChoiceValues({
      haba: haba,
      depth: depth,
      height: height,
      color: color,
      optionText: optionText,
      shopMark: getShopMark(haba, depth, height),
      price: price
    });

    $('.check_price').text(formatYen(price));
    $msg.append('<p class="note-submit-ok">以下の内容を確認し、買い物かごにお進みください。</p>');
    setCheckoutUIEnabled(true);
    return false;
  };

  window.checkBtn = function () { return true; };

  $(function () {
    loadPriceOnce();
    loadExistingOnce();
    bindResizeAfterLoad();

    setMaterialBubble();
    updateInnerDisplays();
    updatePreviewImages();
    resizeFormSizeImages();
    resetOrderSummary();
    syncHoleArea();
    $('.op_hole--position').hide();

    $(window).on('resize', resizeFormSizeImages);
    $(window).on('pageshow', function () {
      setMaterialBubble();
      updateInnerDisplays();
      updatePreviewImages();
      resizeFormSizeImages();
    });

    $(document).on('change', 'input[name="colortype"]', function () {
      if (!this.checked) return;
      setMaterialBubble();
      updateInnerDisplays();
      updatePreviewImages();
    });

    $(document).on('change', '#op_hole', syncHoleArea);

    $(document).on('change', 'input[name="op_panel"]', function () {
      if (this.checked) renderHolePanel(this.id);
    });

    $(document).on('input', '#haba, #depth, #height', function () {
      const cleaned = onlyDigits(this.value);
      if (this.value !== cleaned) this.value = cleaned;
      updateInnerDisplayOne(this.id);
      updatePreviewImages();
    });

    $(document).on('blur', '#haba, #depth, #height', function () {
      validateSizeFieldForBlur(this.id);
    });

    $('form[name="frm_detail"]').on('change input', 'input, select, textarea', function () {
      if ($(this).is('#units, #choice1, #choice2, #choice3, #choice4, #choice5, #choice6, #choice7')) return;
      resetOrderSummary();
    });

    $(document).on('click', '#modal-cart, .btn-cart, .cartadd', submitToRakutenCart);

    $(document).on('submit', 'form[name="frm_detail"], form[name="frm"]', function (e) {
      e.preventDefault();
      submitToRakutenCart(e);
      return false;
    });

    window.setTimeout(function () {
      $('input[name="colortype"]:checked').triggerHandler('change');
    }, 0);
  });

})(jQuery);
